import { render, staticRenderFns } from "./onUploadSuccess-editor.vue?vue&type=template&id=dc04a4a8&scoped=true"
import script from "./onUploadSuccess-editor.vue?vue&type=script&lang=js"
export * from "./onUploadSuccess-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc04a4a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc04a4a8')) {
      api.createRecord('dc04a4a8', component.options)
    } else {
      api.reload('dc04a4a8', component.options)
    }
    module.hot.accept("./onUploadSuccess-editor.vue?vue&type=template&id=dc04a4a8&scoped=true", function () {
      api.rerender('dc04a4a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onUploadSuccess-editor.vue"
export default component.exports